/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable linebreak-style */
import React from "react";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { ButtonDropdown, Dropdown, DropdownMenu, DropdownToggle } from "reactstrap";
import {
  COLLAPSED_DRAWER,
  FIXED_DRAWER,
  HORIZONTAL_NAVIGATION,
  INSIDE_THE_HEADER,
} from "constants/ActionTypes";
import { switchLanguage, toggleCollapsedNav, resetApp } from "actions";
import { isWebview } from "../../util/generalFunction";
import SearchBox from "../../components/SearchBox";
import MailNotification from "../MailNotification/index";
import AppNotification from "../AppNotification/index";
import CardHeader from "../../components/dashboard/Common/CardHeader/index";
import IntlMessages from "../../util/IntlMessages";
import LanguageSwitcher from "../../components/LanguageSwitcher/index";
import UserInfo from "../../components/UserInfo";
import Menu from "../../components/Header/Menu";
import createHistory from "history/createHashHistory";

const history = createHistory();

class Header extends React.Component {
  constructor() {
    super();
    this.state = {
      searchBox: false,
      searchText: "",
      mailNotification: false,
      langSwitcher: false,
      appNotification: false,
      userInfo: false,
    };
  }

  onAppNotificationSelect = () => {
    this.setState({
      appNotification: !this.state.appNotification,
    });
  };
  onMailNotificationSelect = () => {
    this.setState({
      mailNotification: !this.state.mailNotification,
    });
  };

  onUserInfoSelect = () => {
    this.setState({
      userInfo: !this.state.userInfo,
    });
  };

  onLangSwitcherSelect = event => {
    this.setState({
      langSwitcher: !this.state.langSwitcher,
    });
  };
  onSearchBoxSelect = () => {
    this.setState({
      searchBox: !this.state.searchBox,
    });
  };

  onToggleCollapsedNav = () => {
    //
    const val = !this.props.navCollapsed;
    //
    this.props.toggleCollapsedNav(val);
  };

  handleRequestClose = () => {
    this.setState({
      langSwitcher: false,
      mailNotification: false,
      appNotification: false,
      searchBox: false,
    });
  };

  updateSearchText(evt) {
    this.setState({
      searchText: evt.target.value,
    });
  }

  render() {
    //
    const { drawerType, locale, navigationStyle, horizontalNavPosition, user } = this.props;
    //
    const drawerStyle = drawerType.includes(FIXED_DRAWER)
      ? "d-flex d-xl-none"
      : // "d-flex"
      drawerType.includes(COLLAPSED_DRAWER)
      ? "d-flex"
      : "d-none";

    let businessName = user.business.name;
    console.log("TCL: Header -> render -> businessName", businessName)
    // console.log("hello", businessName.length)
    // { console.log(('business' in user) ? businessName.name : null)}
    if(businessName.length > 15) {
      businessName = businessName.slice(0, 15);
      console.log("TCL: Header -> render -> businessName1", businessName)
      businessName += "...";
    }
    return (
      <div
        className="app-main-header"
        style={isWebview() ? { background: "#5d6e7b", color: "#fff" } : {}}
      >
        <div className="d-flex app-toolbar align-items-center">
          {isWebview() ? (
            <React.Fragment>
              <img
                src="../../assets/images/vibo_logo.png"
                style={{ height: "37px", marginBottom: "12px", alignContent: "left" }}
              />
              <span className="businessTitleW">{ ('business' in user) ? businessName.name : null}</span>
            </React.Fragment>
          ) : (
            <span
              className={`jr-menu-icon pointer ${drawerStyle}`}
              onClick={() => this.onToggleCollapsedNav()}
            >
              <span className="menu-icon" />
            </span>
          )}
          {/* <SearchBox
            styleName="d-none d-lg-block"
            onChange={this.updateSearchText.bind(this)}
            value={this.state.searchText}
          /> */}
          {isWebview()? null :<span className="businessTitle">{ ('business' in user) ? user.business.name.name : null}</span>}
          <ul className="header-notifications list-inline ml-auto">
            {/* <li className="d-inline-block d-lg-none list-inline-item">
              <Dropdown
                className="quick-menu nav-searchbox"
                isOpen={this.state.searchBox}
                toggle={this.onSearchBoxSelect.bind(this)}
              >
                <DropdownToggle className="d-inline-block" tag="span" data-toggle="dropdown">
                  <span className="icon-btn size-30">
                    <i className="zmdi zmdi-search zmdi-hc-fw" />
                  </span>
                </DropdownToggle>

                <DropdownMenu right className="p-0">
                  <SearchBox
                    styleName="search-dropdown"
                    placeholder=""
                    onChange={this.updateSearchText.bind(this)}
                    value={this.state.searchText}
                  />
                </DropdownMenu>
              </Dropdown>
            </li> */}
            <li className="list-inline-item">
              <Dropdown
                className="quick-menu mr-2 pointer"
                isOpen={this.state.langSwitcher}
                toggle={this.onLangSwitcherSelect.bind(this)}
              >
                <DropdownToggle className="d-inline-block" tag="span" data-toggle="dropdown" caret>
                  <div className="d-inline-block align-items-center  mr-1">
                    {/* <i className={`flag flag-24 flag-${locale.name}`} /> */}
                    {`${locale.name}`}
                  </div>
                </DropdownToggle>

                <DropdownMenu right className="w-50">
                  <LanguageSwitcher
                    switchLanguage={this.props.switchLanguage}
                    handleRequestClose={this.handleRequestClose}
                  />
                </DropdownMenu>
              </Dropdown>
            </li>
            {/* <li className="list-inline-item app-tour">
              <Dropdown
                className="quick-menu"
                isOpen={this.state.appNotification}
                toggle={this.onAppNotificationSelect.bind(this)}
              >
                <DropdownToggle className="d-inline-block" tag="span" data-toggle="dropdown">
                  <span className="icon-btn size-20 font-size-16">
                    <i className="zmdi zmdi-notifications-active zmdi-hc-lg icon-alert" />
                  </span>
                </DropdownToggle>

                <DropdownMenu right>
                  <CardHeader
                    styleName="align-items-center"
                    heading={<IntlMessages id="appNotification.title" />}
                  />
                  <AppNotification />
                </DropdownMenu>
              </Dropdown>
            </li> */}
            {/* <li className="list-inline-item mail-tour">
              <Dropdown
                className="quick-menu"
                isOpen={this.state.mailNotification}
                toggle={this.onMailNotificationSelect.bind(this)}
              >
                <DropdownToggle className="d-inline-block" tag="span" data-toggle="dropdown">
                  <span className="icon-btn size-20 font-size-16">
                    <i className="zmdi zmdi-comment-alt-text icon-alert zmdi-hc-lg" />
                  </span>
                </DropdownToggle>

                <DropdownMenu right>
                  <CardHeader
                    styleName="align-items-center"
                    heading={<IntlMessages id="mailNotification.title" />}
                  />
                  <MailNotification />
                </DropdownMenu>
              </Dropdown>
            </li> */}
            <li className="list-inline-item user-nav">
              <Dropdown 
                className="quick-menu"
                isOpen={this.state.userInfo}
                toggle={this.onUserInfoSelect.bind(this)}
              >
                <DropdownToggle className="d-inline-block" tag="span" data-toggle="dropdown">
                  <img
                    alt="..."
                    src={user.business && user.business.logo ? user.business.logo.url : ""}
                    className="pointer user-avatar size-30"
                  />
                </DropdownToggle>

                <DropdownMenu right>
                  <UserInfo resetApp={this.props.resetApp} />
                </DropdownMenu>
              </Dropdown>
            </li>
          </ul>
        </div>
      </div>
    );
  }
}

const mapStateToProps = ({ login, settings }) => {
  const { drawerType, navCollapsed, locale, navigationStyle, horizontalNavPosition } = settings;
  const { user } = login;
  //
  return {
    drawerType,
    locale,
    navCollapsed,
    navigationStyle,
    horizontalNavPosition,
    user,
  };
};

export default withRouter(
  connect(
    mapStateToProps,
    { toggleCollapsedNav, switchLanguage, resetApp }
  )(Header)
);



// WEBPACK FOOTER //
// ./components/Header/index.js